import { format, parse } from "date-fns";
import { enUS, es, it } from "date-fns/locale";

const locales = {
  en: enUS,
  es: es,
  it: it,
};

export const formatDate = (date, isTimeEnabled = true) => {
  const storedLocale = localStorage.getItem("language");
  const locale = locales[storedLocale] || enUS;
  const dateFormat = isTimeEnabled ? "MMMM dd, yyyy H:mm a" : "MMMM dd, yyyy";
  return format(date, dateFormat, { locale });
};

export const convertUtcIso = (dateString) => {
  const parsedDate = parse(dateString, "yyyy-M-d HH:mm", new Date());
  return parsedDate.toISOString().replace("Z", "+00:00");
};

export function formatUtcToLocal(dateString) {
  // Treat the timestamp as UTC by adding Z
  const utcDate = new Date(dateString + "Z");

  return format(utcDate, "MMMM dd, yyyy h:mm a");
}